export const AUTH_ERROR = "auth_error";
export const AUTH = "auth";
export const TOKEN = "token";
export const USERID = "userId";
export const TRY_LOGIN = "tryLogin";
export const AUTO_LOGOUT = "autoLogout";
export const SET_USER = "setUser";
export const SET_USER_TYPE_INFO = "setUserTypeInfo";
export const LOGGED_USER = "loggedUser";
export const IS_LOGGED_IN = "signedIn";
export const LOGOUT = "logout";
export const SET_AUTO_LOGOUT = "setAutoLogout";
export const FETCH_CLIENT = "clients/fetchClient";
export const FETCH_CONTRACTOR = "contractors/fetchContractor";
export const SYS_ADM = "sysadmin";
export const CLIENT = "client";
export const CONTRACTOR = "contractor";
export const SERVICE_TYPES = {
  plomeria: "plomeria",
  electricidad: "electricidad",
  pintura: "pintura",
  remodelacion: "remodelación",
  seguridad: "seguridad electrónica",
  herreria: "herreria",
  limpieza: "limpieza",
  jardineria: "jardineria",
  ebanisteria: "ebanisteria",
  mudanza: "mudanza",
  refrigeracion: "refrigeración",
  cerrajero: "cerrajero",
  fomigacion: "fomigación"
};
